module.exports = __webpack_public_path__ + "img/icon11.266448c6.png";